import { useCallback, useMemo } from 'react';
import './styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsNewMission } from 'ui/store/actions/gameUIActions';
import { useLocalStorage } from 'ui/hooks/useLocalStorage';
import { UIRootState } from 'ui/store/reducers';
import { GAEvent, GAEventNames } from 'game/analytics/events';
import { translate } from 'game/translate';

interface StoriesButtonProps {
    type: 'main' | 'secondary';
    onClick: () => void;
    isSelected?: boolean;
    disabled?: boolean;
}

export const StoriesButton: React.FC<StoriesButtonProps> = ({ onClick, type, isSelected, disabled }) => {
    const dispatch = useDispatch();
    const [tickets] = useLocalStorage<number>('stories_tickets_counter', 0);
    const stories = useSelector((state: UIRootState) => state.gameUI.modals.storiesModal.stories);

    const isVisited = localStorage.getItem('stories-visited') == 'true';

    const handleStoriesClick = useCallback(() => {
        localStorage.setItem('stories-visited', 'true');
        GAEvent(GAEventNames.STORIES_BUTTON_CLICK);
        onClick();
    }, [onClick, dispatch, toggleIsNewMission]);

    const isHaveAvailableStories = useMemo(() => {
        return tickets >= 50 && !!stories.find((story, index) => {
            const progress = parseInt(localStorage.getItem(`stories_story_${index + 1}_progress`) || '0');

            return progress < story.totalImages;
        });
    }, [tickets, stories]);

    return (
        <div id="closing-ignore-el" style={isSelected ? { background: 'rgba(31, 31, 31, 0.40)' } : {}} className={`mission-button stories-button--${type} d-flex justify-content-center ${type === 'secondary' ? '' : 'w-100'}  ${type === 'secondary' ? '' : 'side-bar-button--wrapper'}`}>
            <button 
                id="missionsButton" 
                onClick={handleStoriesClick}
                disabled={disabled}
                className={`${type === 'secondary' ? 'side-bar-button side-bar-button--secondary' : 'side-bar-button'} position-relative d-flex align-items-center justify-content-center w-100`}
            >
                <picture>
                    <source srcSet={`/assets/menu/icon_stories.webp`} type="image/webp" />
                    <img style={{ height: '50px' }} src={`/assets/menu/icon_stories.png`} alt="Stories" />
                </picture>

                <span>
                    {translate('menu_stories')}
                </span>
            </button>

            {(!isVisited || isHaveAvailableStories) && <div className={`stories-button-indicator stories-button-indicator--${type}`}/>}
        </div>
    );
};